import { userCoreDetailsSchema } from './user'
import { z } from 'zod'

const emailReceiverSchema = z.object({
  email: z.email(),
  id: z.string(),
})
const userReceiverSchema = z.object({
  user: userCoreDetailsSchema,
  id: z.string(),
})

export type EmailReceiver = z.infer<typeof emailReceiverSchema>
export type UserReceiver = z.infer<typeof userReceiverSchema>

export const alertReceiverSchema = z.union([
  emailReceiverSchema,
  userReceiverSchema,
])

export type AlertReceiver = z.infer<typeof alertReceiverSchema>
